import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { OAuthService } from '../services/oauth.service';
import { ROLES } from '../models/livekit.model';
import { LivekitService } from '../services/livekit.service';

export const LogoutGuard: CanActivateFn = () => {
  const authService = inject(OAuthService);
  const livekit = inject(LivekitService);
  const router = inject(Router);

  return authService.signOut().pipe(
    map(() => {
      ROLES.forEach((role) => sessionStorage.removeItem(livekit.getTokenStorageKey(role)));
      return router.parseUrl('login');
    }),
  );
};
